export default (
  state = {
    activeImage: 0,
    initialRender: true,
    rerenderGallery: true,
    mobileSlider: null,
    tabletSlider: null,
    desktopSlider: null,
  },
  action
) => {
  switch (action.type) {
    case 'IMAGE_CONTROLLER':
      return {
        ...state,
        activeImage: action.activeIndex,
      };
    case 'RERENDER_GALLERY':
      return {
        ...state,
        rerenderGallery: action.status,
      };
    case 'REGISTER_SLIDER':
      return {
        ...state,
        [action.sliderType]: action.sliderEl,
      };
    default:
      return state;
  }
};
